export default {
  title: 'Weet je zeker dat je je account wilt verwijderen?',
  description:
    'Deze actie is permanent. Je verliest toegang tot je bestellingen, loyaliteitspunten en opgeslagen voorkeuren.',
  labels: {
    loading: 'Account wordt verwijderd...',
  },
  buttons: {
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
  },
  toasts: {
    success:
      'Je account is permanent verwijderd. Je hebt geen toegang meer tot je bestelgeschiedenis, loyaliteitspunten of opgeslagen gegevens.',
    error:
      'Er is iets misgegaan. Probeer het opnieuw. Als het probleem aanhoudt, neem dan contact op met ons ondersteuningsteam: {{supportEmail}}',
  },
};
